<div class="create-dialog-box">
    <div class="title d-flex align-items-center justify-content-space-between">
        <h4 class="mb-0">File upload</h4>
        <button class="close-btn bg-transparent p-0 border-none" (click)="close()"><i
                class="flaticon-close"></i></button>
    </div>
    <form>
        <ngx-dropzone (change)="onSelectFile($event)" [multiple]="true">
            <ngx-dropzone-label class="fw-semibold">Please select file to upload</ngx-dropzone-label>
            <ng-container *ngFor="let f of files">
                <ng-container *ngIf="file_type(f.name); else no_img">
                    <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" [file]="f" [removable]="true"
                        (removed)="onRemove(f)">
                        <ngx-dropzone-label>
                            <!-- {{ f.name }} ({{ f.type }}) -->
                            {{ f.name | slice:0:10}}
                            <span *ngIf="f?.name?.length > 10" [matTooltip]="f?.name">...</span>
                        </ngx-dropzone-label>
                    </ngx-dropzone-image-preview>
                </ng-container>
                <ng-template #no_img>
                    <ngx-dropzone-preview [removable]="true" (removed)="onRemove(f)">
                        <ngx-dropzone-label>
                            <!-- {{ f?.name }} ({{ f?.type }}) -->
                            {{ f?.name | slice:0:10 }}
                            <span *ngIf="f?.name?.length > 10" [matTooltip]="f?.name">...</span>
                        </ngx-dropzone-label>
                    </ngx-dropzone-preview>
                </ng-template>
            </ng-container>
        </ngx-dropzone>
    </form>
</div>